import type { ReactNode } from 'react';

export const symbol_nest_found_savings: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-160H180q-24 0-42-18.5T120-220v-600q0-24 18-42t42-18h600q23 0 41.5 18t18.5 42v600q0 23-18.5 41.5T780-160H600l-99 99q-9 9-21 9t-21-9l-99-99Zm-180-60h204l96 96 96-96h204v-600H180v600Zm300-297Zm.1 187q80.9 0 135.4-57T670-520v-160q0-12.75-8.62-21.38Q652.75-710 640-710H480q-76.95 0-133.48 54.27Q290-601.45 290-519.57q0 28.57 9 55.07t26 52.5l-22 22q-9 9-9 21t9 21q9 9 21 9t21-9l21-20q26 18 55 28t59.1 10Zm-.1-60q-17 0-35-6t-36-15l114-114q9-9.07 9-21.53 0-12.47-9-21.47-9-9-21-9t-21 9L366-453q-8-19-12-36t-4-31.2q0-56.8 39-93.3t91-36.5h130v130q0 54.17-37.92 92.08Q534.17-390 480-390Zm-25-110Z"
		/>
	</svg>
);
